import { httpService } from "./HttpService";
import ApiPaths from "./ApiPaths";

export const generateReport = async (sessionId: string): Promise<Blob> => {
    try {
        
        const response = await httpService.get(`${ApiPaths.SESSIONS_DOWNLOAD}/${sessionId}`, {
            responseType: 'arraybuffer',
        });

        return new Blob([response.data as ArrayBuffer], { type: 'application/pdf' });

    } catch (error) {
        console.error('Error generating report:', error);
        throw error;
    }
}